import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Sidebar from "./components/Page Component/Sidebar";
import { Route, Routes } from "react-router-dom";
import LinkRoutes from "./Routes/Link";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setIsLoggedIn } from "./store/AuthSlice";
import { createTheme, ThemeProvider } from "@mui/material";
import { ChakraProvider } from "@chakra-ui/react";
import NotificationContainer from "./components/Container/NotificationContainer";
import { setFields } from "./store/Personslice";
import { fetchData } from "./store/actions";
import { ViewUser } from "./Service/Apis";
import type { AppDispatch } from "./store/Store"; 


const theme = createTheme({
	typography: {
		fontFamily: ["Signika Negative"].join(","),
		// fontSize: "1rem",
	},
	palette: {
		primary: {
			main: "#007300",
			contrastText: "#ffff",
			//button text white instead of black
		},
		background: {
			default: "#007300",
		},
		success: {
			main: "#007300",
		},
	},

	components: {
		MuiIconButton: {
			styleOverrides: {
				colorPrimary: "#007300",
			},
		},
		MuiBadge: {
			styleOverrides: {
				colorPrimary: "#007300",
			},
		},
		MuiAvatar: {
			styleOverrides: {
				root: {
					backgroundColor: "#007300",
					color: "#ffffff",
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				containedInfo: {
					backgroundColor: "#007300", // Override background color for contained success button
					"&:hover": {
						backgroundColor: "#007300", // Override hover color for contained success button
					},
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				input: {
					"&::placeholder": {
						color: "#000000",
						opacity: 1,
					},
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					color: "#000000",
					"&.Mui-focused": {
						color: "#000000",
					},
					"&.MuiInputLabel-shrink": {
						color: "#000000",
					},
				},
			},
		},
		MuiFormControlLabel: {
			styleOverrides: {
				label: {
					color: "#000000",
				},
			},
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {
					color: "#007300", // Change text color for MuiMenuItem
					"&.Mui-selected": {
						color: "#000000",
					},
					"&.Mui-selected:hover": {
						color: "#000000",
					},
				},
			},
		},
		MuiTypography: {
			styleOverrides: {
				h1: {
					color: "#007300", // Override text color for success typography
				},
				h2: {
					color: "#007300", // Override text color for success typography
				},
				h3: {
					color: "#007300", // Override text color for success typography
				},
				h4: {
					color: "#007300", // Override text color for success typography
				},
				h5: {
					color: "#007300", // Override text color for success typography
				},
				h6: {
					color: "#007300", // Override text color for success typography
				},
			},
		},
		// Add more component overrides as needed
	},
});
function App() {
	// const checkToken=():boolean => {
	// 	if(token&&islogged){return true}
	// 	return false
	// }
	// console.log(process.env.REACT_APP_API_ENDPOINT_PROD);
	// console.log(process.env.REACT_APP_API_ENDPOINT_LOCAL);
	const dispatch: AppDispatch = useDispatch();

	// Retrieve the user's email and authentication token from localStorage.
	// - The token is required to authenticate API requests to the backend.
	// - The email is used as a unique identifier to fetch the user's profile from the backend API.
	const email = localStorage.getItem("email");
	const token = localStorage.getItem("token");

	// On app load or when the token/email changes, fetch the user profile from the backend.
	// This ensures that the user's profile (including their unique user ID) is always available in Redux (Personslice).
	// The user ID is not available in Redux until we fetch the profile using the email and token.
	// Once fetched, the user ID and other profile details are stored in Redux for use throughout the app.
	useEffect(() => {
		const fetchUserProfile = async () => {
		  if (token && email) {
			try {
			// Make an authenticated API call to fetch the user profile using the email
			  const response = await dispatch(fetchData(`${ViewUser}${email}`));
			// If the response is valid, update the Personslice in Redux with the user data (including user ID)
			  if (response && response[0]) {
				dispatch(setFields(response[0]));
			  }
			} catch (err) {
			}
		  }
		};
		fetchUserProfile();
	  }, [token, email, dispatch]);
	

	return (
		<>
			<ThemeProvider theme={theme}>
				<NotificationContainer />
				<LinkRoutes />
				</ThemeProvider>
		</>
	);
}

export default App;
